"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_IS_ALL_TASK_COMMENTS_FETCHED = exports.SET_IS_TASK_COMMENTS_PAGINATING = exports.SET_PENDING_TASK_COMMENT_IDS = exports.RECEIVE_TASK_COMMENTS = exports.START_TASK_COMMENTS_GET = exports.SET_IS_UPDATE_SNACKBAR_OPEN = exports.CALCULATE_PROJECT_SELECTOR_INDICATORS = exports.SET_IS_PROJECT_MENU_OPEN = exports.RECEIVE_COMPLETED_REMOTE_TASKS = exports.RECEIVE_INCOMPLETED_REMOTE_TASKS = exports.RECEIVE_COMPLETED_LOCAL_TASKS = exports.RECEIVE_INCOMPLETED_LOCAL_TASKS = exports.SET_SHOW_COMPLETED_TASKS = exports.CANCEL_TASK_MOVE = exports.SET_IS_IN_REGISTER_MODE = exports.SET_TEXT_INPUT_DIALOG = exports.SET_SHOW_ONLY_SELF_TASKS = exports.SET_OPEN_TASK_OPTIONS_ID = exports.SET_OPEN_PROJECT_SELECTOR_ID = exports.SET_OPEN_TASK_LIST_WIDGET_HEADER_ID = exports.OPEN_TASK_INFO = exports.CLOSE_TASK_INFO = exports.SET_IS_RESTORE_DATABASE_COMPLETE_DIALOG_OPEN = exports.SET_IS_DISPLAY_NAME_UPDATE_REQURIED = exports.SET_UPDATING_INVITE_IDS = exports.SET_UPDATING_USER_IDS = exports.RECEIVE_INVITES = exports.RECEIVE_MEMBERS = exports.RECEIVE_REMOTE_PROJECT_LAYOUT = exports.RECEIVE_REMOTE_PROJECT_IDS = exports.SET_DISPLAY_NAME = exports.SET_SHARE_MENU_SUB_MESSAGE = exports.SET_SHARE_MENU_MESSAGE = exports.SET_IS_SHARE_MENU_WAITING = exports.CLOSE_SHARE_MENU = exports.OPEN_SHARE_MENU = exports.SET_ALL_COLORS_TO_DEFAULT = exports.SET_IS_APP_DRAWER_OPEN = exports.DISMISS_SNACKBAR = exports.SET_GENERAL_SNACKBAR = exports.CLEAR_DATA = exports.SET_USER_EMAIL = exports.SET_IS_LOGGED_IN_FLAG = exports.SET_IS_LOGGING_IN_FLAG = exports.SET_AUTH_STATUS_MESSAGE = exports.SET_MESSAGE_BOX = exports.SET_CSS_CONFIG = exports.RECEIVE_CSS_CONFIG = exports.GET_CSS_CONFIG = exports.SET_IGNORE_FULLSCREEN_TRIGGER_FLAG = exports.RECEIVE_ACCOUNT_CONFIG = exports.SET_FAVOURITE_PROJECT_ID = exports.SET_IS_APP_SETTINGS_OPEN = exports.SET_IS_DEXIE_CONFIG_LOAD_COMPLETE_FLAG = exports.SET_IS_STARTING_UP_FLAG = exports.SET_GENERAL_CONFIG = exports.RECEIVE_GENERAL_CONFIG = exports.GET_GENERAL_CONFIG = exports.SET_IS_DATABASE_RESTORING_FLAG = exports.PURGE_COMPLETE_TASKS = exports.SET_DATABASE_PURGING_FLAG = exports.SET_DATABASE_INFO = exports.GET_DATABASE_INFO = exports.SET_APP_SETTINGS_MENU_PAGE = exports.SET_IS_SHUTTING_DOWN_FLAG = exports.CLOSE_JUMP_MENU = exports.OPEN_JUMP_MENU = exports.SET_TASK_PRIORITY = exports.SET_TASKS_HAVE_PENDING_WRITES = exports.SET_TASKLISTS_HAVE_PENDING_WRITES = exports.SET_PROJECTLAYOUTS_HAVE_PENDING_WRITES = exports.SET_PROJECTS_HAVE_PENDING_WRITES = exports.SELECT_PROJECT = exports.RECEIVE_REMOTE_PROJECTLAYOUTS = exports.RECEIVE_LOCAL_PROJECTLAYOUTS = exports.START_PROJECTLAYOUTS_FETCH = exports.RECEIVE_REMOTE_TASKLISTS = exports.RECEIVE_LOCAL_TASKLISTS = exports.CHANGE_TASKLIST_WIDGET_HEADER = exports.START_TASK_ADD = exports.START_TASKLIST_ADD = exports.SET_OPEN_TASKLIST_SETTINGS_MENU_ID = exports.SET_LAST_BACKUP_DATE = exports.UNLOCK_APP = exports.LOCK_APP = exports.START_TASKLISTS_FETCH = exports.START_TASKS_FETCH = exports.RECEIVE_REMOTE_PROJECTS = exports.RECEIVE_LOCAL_PROJECTS = exports.START_PROJECTS_FETCH = exports.GET_PROJECTS = exports.END_TASK_MOVE = exports.START_TASK_MOVE_IN_DATABASE = exports.START_TASK_MOVE = exports.CLOSE_TASK = exports.OPEN_TASK = exports.SELECT_TASK = exports.SET_FOCUSED_TASKLIST_ID = exports.END_PROJECT_DATABASE_CHANGE = exports.START_PROJECT_DATABASE_CHANGE = void 0;
exports.SET_IS_APP_DRAWER_COLLAPSED = exports.SET_UNDO_SNACKBAR = exports.SET_LAST_UNDO_ACTION = exports.SET_IS_INDUCTING = exports.STEP_ONBOARDER_BACKWARDS = exports.STEP_ONBOARDER_FORWARD = exports.SET_IS_ONBOARDING = exports.SELECT_MUI_THEME = exports.RECEIVE_LOCAL_MUI_THEMES = exports.SET_QUICK_ITEM_SELECT_DIALOG = exports.SET_ITEM_SELECT_DIALOG = exports.SET_CONFIRMATION_DIALOG = exports.SET_INFORMATION_DIALOG = exports.CLOSE_CHECKLIST_SETTINGS = exports.OPEN_CHECKLIST_SETTINGS = exports.SET_SELECTED_PROJECT_LAYOUT_TYPE = exports.CLOSE_TASK_INSPECTOR = exports.OPEN_TASK_INSPECTOR = exports.SET_OPEN_TASK_INSPECTOR_ID = void 0;
var START_PROJECT_DATABASE_CHANGE = 'START_PROJECT_DATABASE_CHANGE';
exports.START_PROJECT_DATABASE_CHANGE = START_PROJECT_DATABASE_CHANGE;
var END_PROJECT_DATABASE_CHANGE = 'END_PROJECT_DATABASE_CHANGE';
exports.END_PROJECT_DATABASE_CHANGE = END_PROJECT_DATABASE_CHANGE;
var SET_FOCUSED_TASKLIST_ID = "SET_FOCUSED_TASKLIST_ID";
exports.SET_FOCUSED_TASKLIST_ID = SET_FOCUSED_TASKLIST_ID;
var SELECT_TASK = "SELECT_TASK";
exports.SELECT_TASK = SELECT_TASK;
var OPEN_TASK = "OPEN_TASK";
exports.OPEN_TASK = OPEN_TASK;
var CLOSE_TASK = 'CLOSE_TASK';
exports.CLOSE_TASK = CLOSE_TASK;
var START_TASK_MOVE = "START_TASK_MOVE";
exports.START_TASK_MOVE = START_TASK_MOVE;
var START_TASK_MOVE_IN_DATABASE = 'START_TASK_MOVE_IN_DATABASE';
exports.START_TASK_MOVE_IN_DATABASE = START_TASK_MOVE_IN_DATABASE;
var END_TASK_MOVE = "END_TASK_MOVE";
exports.END_TASK_MOVE = END_TASK_MOVE;
var GET_PROJECTS = "GET_PROJECTS";
exports.GET_PROJECTS = GET_PROJECTS;
var START_PROJECTS_FETCH = 'START_PROJECTS_FETCH';
exports.START_PROJECTS_FETCH = START_PROJECTS_FETCH;
var RECEIVE_LOCAL_PROJECTS = 'RECEIVE_LOCAL_PROJECTS';
exports.RECEIVE_LOCAL_PROJECTS = RECEIVE_LOCAL_PROJECTS;
var RECEIVE_REMOTE_PROJECTS = 'RECEIVE_REMOTE_PROJECTS';
exports.RECEIVE_REMOTE_PROJECTS = RECEIVE_REMOTE_PROJECTS;
var START_TASKS_FETCH = 'START_TASKS_FETCH';
exports.START_TASKS_FETCH = START_TASKS_FETCH;
var START_TASKLISTS_FETCH = 'START_TASKLISTS_FETCH';
exports.START_TASKLISTS_FETCH = START_TASKLISTS_FETCH;
var LOCK_APP = 'LOCK_APP';
exports.LOCK_APP = LOCK_APP;
var UNLOCK_APP = 'UNLOCK_APP';
exports.UNLOCK_APP = UNLOCK_APP;
var SET_LAST_BACKUP_DATE = 'SET_LAST_BACKUP_DATE';
exports.SET_LAST_BACKUP_DATE = SET_LAST_BACKUP_DATE;
var SET_OPEN_TASKLIST_SETTINGS_MENU_ID = 'SET_OPEN_TASKLIST_SETTINGS_MENU_ID';
exports.SET_OPEN_TASKLIST_SETTINGS_MENU_ID = SET_OPEN_TASKLIST_SETTINGS_MENU_ID;
var START_TASKLIST_ADD = 'START_TASKLIST_ADD';
exports.START_TASKLIST_ADD = START_TASKLIST_ADD;
var START_TASK_ADD = 'START_TASK_ADD';
exports.START_TASK_ADD = START_TASK_ADD;
var CHANGE_TASKLIST_WIDGET_HEADER = 'CHANGE_TASKLIST_WIDGET_HEADER';
exports.CHANGE_TASKLIST_WIDGET_HEADER = CHANGE_TASKLIST_WIDGET_HEADER;
var RECEIVE_LOCAL_TASKLISTS = 'RECEIVE_LOCAL_TASKLISTS';
exports.RECEIVE_LOCAL_TASKLISTS = RECEIVE_LOCAL_TASKLISTS;
var RECEIVE_REMOTE_TASKLISTS = 'RECEIVE_REMOTE_TASKLISTS';
exports.RECEIVE_REMOTE_TASKLISTS = RECEIVE_REMOTE_TASKLISTS;
var START_PROJECTLAYOUTS_FETCH = 'START_PROJECTLAYOUTS_FETCH';
exports.START_PROJECTLAYOUTS_FETCH = START_PROJECTLAYOUTS_FETCH;
var RECEIVE_LOCAL_PROJECTLAYOUTS = 'RECEIVE_LOCAL_PROJECTLAYOUTS';
exports.RECEIVE_LOCAL_PROJECTLAYOUTS = RECEIVE_LOCAL_PROJECTLAYOUTS;
var RECEIVE_REMOTE_PROJECTLAYOUTS = 'RECEIVE_REMOTE_PROJECTLAYOUTS';
exports.RECEIVE_REMOTE_PROJECTLAYOUTS = RECEIVE_REMOTE_PROJECTLAYOUTS;
var SELECT_PROJECT = 'SELECT_PROJECT';
exports.SELECT_PROJECT = SELECT_PROJECT;
var SET_PROJECTS_HAVE_PENDING_WRITES = 'SET_PROJECTS_HAVE_PENDING_WRITES';
exports.SET_PROJECTS_HAVE_PENDING_WRITES = SET_PROJECTS_HAVE_PENDING_WRITES;
var SET_PROJECTLAYOUTS_HAVE_PENDING_WRITES = 'SET_PROJECTLAYOUTS_HAVE_PENDING_WRITES';
exports.SET_PROJECTLAYOUTS_HAVE_PENDING_WRITES = SET_PROJECTLAYOUTS_HAVE_PENDING_WRITES;
var SET_TASKLISTS_HAVE_PENDING_WRITES = 'SET_TASKLISTS_HAVE_PENDING_WRITES';
exports.SET_TASKLISTS_HAVE_PENDING_WRITES = SET_TASKLISTS_HAVE_PENDING_WRITES;
var SET_TASKS_HAVE_PENDING_WRITES = 'SET_TASKS_HAVE_PENDING_WRITES';
exports.SET_TASKS_HAVE_PENDING_WRITES = SET_TASKS_HAVE_PENDING_WRITES;
var SET_TASK_PRIORITY = 'SET_TASK_PRIORITY';
exports.SET_TASK_PRIORITY = SET_TASK_PRIORITY;
var OPEN_JUMP_MENU = 'OPEN_JUMP_MENU';
exports.OPEN_JUMP_MENU = OPEN_JUMP_MENU;
var CLOSE_JUMP_MENU = 'CLOSE_JUMP_MENU';
exports.CLOSE_JUMP_MENU = CLOSE_JUMP_MENU;
var SET_IS_SHUTTING_DOWN_FLAG = 'SET_IS_SHUTTING_DOWN_FLAG';
exports.SET_IS_SHUTTING_DOWN_FLAG = SET_IS_SHUTTING_DOWN_FLAG;
var SET_APP_SETTINGS_MENU_PAGE = 'SET_APP_SETTINGS_MENU_PAGE';
exports.SET_APP_SETTINGS_MENU_PAGE = SET_APP_SETTINGS_MENU_PAGE;
var GET_DATABASE_INFO = 'GET_DATABASE_INFO';
exports.GET_DATABASE_INFO = GET_DATABASE_INFO;
var SET_DATABASE_INFO = 'SET_DATABASE_INFO';
exports.SET_DATABASE_INFO = SET_DATABASE_INFO;
var SET_DATABASE_PURGING_FLAG = 'SET_DATABASE_PURGING_FLAG';
exports.SET_DATABASE_PURGING_FLAG = SET_DATABASE_PURGING_FLAG;
var PURGE_COMPLETE_TASKS = 'PURGE_COMPLETE_TASKS';
exports.PURGE_COMPLETE_TASKS = PURGE_COMPLETE_TASKS;
var SET_IS_DATABASE_RESTORING_FLAG = 'SET_IS_DATABASE_RESTORING_FLAG';
exports.SET_IS_DATABASE_RESTORING_FLAG = SET_IS_DATABASE_RESTORING_FLAG;
var GET_GENERAL_CONFIG = 'GET_GENERAL_CONFIG';
exports.GET_GENERAL_CONFIG = GET_GENERAL_CONFIG;
var RECEIVE_GENERAL_CONFIG = 'RECEIVE_GENERAL_CONFIG';
exports.RECEIVE_GENERAL_CONFIG = RECEIVE_GENERAL_CONFIG;
var SET_GENERAL_CONFIG = 'SET_GENERAL_CONFIG';
exports.SET_GENERAL_CONFIG = SET_GENERAL_CONFIG;
var SET_IS_STARTING_UP_FLAG = 'SET_IS_STARTING_UP_FLAG';
exports.SET_IS_STARTING_UP_FLAG = SET_IS_STARTING_UP_FLAG;
var SET_IS_DEXIE_CONFIG_LOAD_COMPLETE_FLAG = 'SET_IS_DEXIE_CONFIG_LOAD_COMPLETE_FLAG';
exports.SET_IS_DEXIE_CONFIG_LOAD_COMPLETE_FLAG = SET_IS_DEXIE_CONFIG_LOAD_COMPLETE_FLAG;
var SET_IS_APP_SETTINGS_OPEN = 'SET_IS_APP_SETTINGS_OPEN';
exports.SET_IS_APP_SETTINGS_OPEN = SET_IS_APP_SETTINGS_OPEN;
var SET_FAVOURITE_PROJECT_ID = 'SET_FAVOURITE_PROJECT_ID';
exports.SET_FAVOURITE_PROJECT_ID = SET_FAVOURITE_PROJECT_ID;
var RECEIVE_ACCOUNT_CONFIG = 'RECEIVE_ACCOUNT_CONFIG';
exports.RECEIVE_ACCOUNT_CONFIG = RECEIVE_ACCOUNT_CONFIG;
var SET_IGNORE_FULLSCREEN_TRIGGER_FLAG = 'SET_IGNORE_FULLSCREEN_TRIGGER_FLAG';
exports.SET_IGNORE_FULLSCREEN_TRIGGER_FLAG = SET_IGNORE_FULLSCREEN_TRIGGER_FLAG;
var GET_CSS_CONFIG = 'GET_CSS_CONFIG';
exports.GET_CSS_CONFIG = GET_CSS_CONFIG;
var RECEIVE_CSS_CONFIG = 'RECEIVE_CSS_CONFIG';
exports.RECEIVE_CSS_CONFIG = RECEIVE_CSS_CONFIG;
var SET_CSS_CONFIG = 'SET_CSS_CONFIG';
exports.SET_CSS_CONFIG = SET_CSS_CONFIG;
var SET_MESSAGE_BOX = 'SET_MESSAGE_BOX';
exports.SET_MESSAGE_BOX = SET_MESSAGE_BOX;
var SET_AUTH_STATUS_MESSAGE = 'SET_AUTH_STATUS_MESSAGE';
exports.SET_AUTH_STATUS_MESSAGE = SET_AUTH_STATUS_MESSAGE;
var SET_IS_LOGGING_IN_FLAG = 'SET_IS_LOGGING_IN_FLAG';
exports.SET_IS_LOGGING_IN_FLAG = SET_IS_LOGGING_IN_FLAG;
var SET_IS_LOGGED_IN_FLAG = 'SET_IS_LOGGED_IN_FLAG';
exports.SET_IS_LOGGED_IN_FLAG = SET_IS_LOGGED_IN_FLAG;
var SET_USER_EMAIL = 'SET_USER_EMAIL';
exports.SET_USER_EMAIL = SET_USER_EMAIL;
var CLEAR_DATA = 'CLEAR_DATA';
exports.CLEAR_DATA = CLEAR_DATA;
var SET_GENERAL_SNACKBAR = 'SET_GENERAL_SNACKBAR';
exports.SET_GENERAL_SNACKBAR = SET_GENERAL_SNACKBAR;
var DISMISS_SNACKBAR = 'DISMISS_SNACKBAR';
exports.DISMISS_SNACKBAR = DISMISS_SNACKBAR;
var SET_IS_APP_DRAWER_OPEN = 'SET_IS_APP_DRAWER_OPEN';
exports.SET_IS_APP_DRAWER_OPEN = SET_IS_APP_DRAWER_OPEN;
var SET_ALL_COLORS_TO_DEFAULT = 'SET_ALL_COLORS_TO_DEFAULT';
exports.SET_ALL_COLORS_TO_DEFAULT = SET_ALL_COLORS_TO_DEFAULT;
var OPEN_SHARE_MENU = 'OPEN_SHARE_MENU';
exports.OPEN_SHARE_MENU = OPEN_SHARE_MENU;
var CLOSE_SHARE_MENU = 'CLOSE_SHARE_MENU';
exports.CLOSE_SHARE_MENU = CLOSE_SHARE_MENU;
var SET_IS_SHARE_MENU_WAITING = 'SET_IS_SHARE_MENU_WAITING';
exports.SET_IS_SHARE_MENU_WAITING = SET_IS_SHARE_MENU_WAITING;
var SET_SHARE_MENU_MESSAGE = 'SET_SHARE_MENU_MESSAGE';
exports.SET_SHARE_MENU_MESSAGE = SET_SHARE_MENU_MESSAGE;
var SET_SHARE_MENU_SUB_MESSAGE = 'SET_SHARE_MENU_SUB_MESSAGE';
exports.SET_SHARE_MENU_SUB_MESSAGE = SET_SHARE_MENU_SUB_MESSAGE;
var SET_DISPLAY_NAME = 'SET_DISPLAY_NAME';
exports.SET_DISPLAY_NAME = SET_DISPLAY_NAME;
var RECEIVE_REMOTE_PROJECT_IDS = 'RECEIVE_REMOTE_PROJECT_IDS';
exports.RECEIVE_REMOTE_PROJECT_IDS = RECEIVE_REMOTE_PROJECT_IDS;
var RECEIVE_REMOTE_PROJECT_LAYOUT = 'RECEIVE_REMOTE_PROJECT_LAYOUT';
exports.RECEIVE_REMOTE_PROJECT_LAYOUT = RECEIVE_REMOTE_PROJECT_LAYOUT;
var RECEIVE_MEMBERS = 'RECEIVE_MEMBERS';
exports.RECEIVE_MEMBERS = RECEIVE_MEMBERS;
var RECEIVE_INVITES = 'RECEIVE_INVITES';
exports.RECEIVE_INVITES = RECEIVE_INVITES;
var SET_UPDATING_USER_IDS = 'SET_UPDATING_USER_IDS';
exports.SET_UPDATING_USER_IDS = SET_UPDATING_USER_IDS;
var SET_UPDATING_INVITE_IDS = 'SET_UPDATING_INVITE_IDS';
exports.SET_UPDATING_INVITE_IDS = SET_UPDATING_INVITE_IDS;
var SET_IS_DISPLAY_NAME_UPDATE_REQURIED = 'SET_IS_DISPLAY_NAME_UPDATE_REQURIED';
exports.SET_IS_DISPLAY_NAME_UPDATE_REQURIED = SET_IS_DISPLAY_NAME_UPDATE_REQURIED;
var SET_IS_RESTORE_DATABASE_COMPLETE_DIALOG_OPEN = 'SET_IS_RESTORE_DATABASE_COMPLETE_DIALOG_OPEN';
exports.SET_IS_RESTORE_DATABASE_COMPLETE_DIALOG_OPEN = SET_IS_RESTORE_DATABASE_COMPLETE_DIALOG_OPEN;
var CLOSE_TASK_INFO = 'CLOSE_TASK_INFO';
exports.CLOSE_TASK_INFO = CLOSE_TASK_INFO;
var OPEN_TASK_INFO = 'OPEN_TASK_INFO';
exports.OPEN_TASK_INFO = OPEN_TASK_INFO;
var SET_OPEN_TASK_LIST_WIDGET_HEADER_ID = 'SET_OPEN_TASK_LIST_WIDGET_HEADER_ID';
exports.SET_OPEN_TASK_LIST_WIDGET_HEADER_ID = SET_OPEN_TASK_LIST_WIDGET_HEADER_ID;
var SET_OPEN_PROJECT_SELECTOR_ID = 'SET_OPEN_PROJECT_SELECTOR_ID';
exports.SET_OPEN_PROJECT_SELECTOR_ID = SET_OPEN_PROJECT_SELECTOR_ID;
var SET_OPEN_TASK_OPTIONS_ID = 'SET_OPEN_TASK_OPTIONS_ID';
exports.SET_OPEN_TASK_OPTIONS_ID = SET_OPEN_TASK_OPTIONS_ID;
var SET_SHOW_ONLY_SELF_TASKS = 'SET_SHOW_ONLY_SELF_TASKS';
exports.SET_SHOW_ONLY_SELF_TASKS = SET_SHOW_ONLY_SELF_TASKS;
var SET_TEXT_INPUT_DIALOG = 'SET_TEXT_INPUT_DIALOG';
exports.SET_TEXT_INPUT_DIALOG = SET_TEXT_INPUT_DIALOG;
var SET_IS_IN_REGISTER_MODE = 'SET_IS_IN_REGISTER_MODE';
exports.SET_IS_IN_REGISTER_MODE = SET_IS_IN_REGISTER_MODE;
var CANCEL_TASK_MOVE = 'CANCEL_TASK_MOVE';
exports.CANCEL_TASK_MOVE = CANCEL_TASK_MOVE;
var SET_SHOW_COMPLETED_TASKS = 'SET_SHOW_COMPLETED_TASKS';
exports.SET_SHOW_COMPLETED_TASKS = SET_SHOW_COMPLETED_TASKS;
var RECEIVE_INCOMPLETED_LOCAL_TASKS = 'RECEIVE_INCOMPLETED_LOCAL_TASKS';
exports.RECEIVE_INCOMPLETED_LOCAL_TASKS = RECEIVE_INCOMPLETED_LOCAL_TASKS;
var RECEIVE_COMPLETED_LOCAL_TASKS = 'RECEIVE_COMPLETED_LOCAL_TASKS';
exports.RECEIVE_COMPLETED_LOCAL_TASKS = RECEIVE_COMPLETED_LOCAL_TASKS;
var RECEIVE_INCOMPLETED_REMOTE_TASKS = 'RECEIVE_INCOMPLETED_REMOTE_TASKS';
exports.RECEIVE_INCOMPLETED_REMOTE_TASKS = RECEIVE_INCOMPLETED_REMOTE_TASKS;
var RECEIVE_COMPLETED_REMOTE_TASKS = 'RECEIVE_COMPLETED_REMOTE_TASKS';
exports.RECEIVE_COMPLETED_REMOTE_TASKS = RECEIVE_COMPLETED_REMOTE_TASKS;
var SET_IS_PROJECT_MENU_OPEN = 'SET_IS_PROJECT_MENU_OPEN';
exports.SET_IS_PROJECT_MENU_OPEN = SET_IS_PROJECT_MENU_OPEN;
var CALCULATE_PROJECT_SELECTOR_INDICATORS = 'CALCULATE_PROJECT_SELECTOR_INDICATORS';
exports.CALCULATE_PROJECT_SELECTOR_INDICATORS = CALCULATE_PROJECT_SELECTOR_INDICATORS;
var SET_IS_UPDATE_SNACKBAR_OPEN = 'SET_IS_UPDATE_SNACKBAR_OPEN';
exports.SET_IS_UPDATE_SNACKBAR_OPEN = SET_IS_UPDATE_SNACKBAR_OPEN;
var START_TASK_COMMENTS_GET = 'START_TASK_COMMENTS_GET';
exports.START_TASK_COMMENTS_GET = START_TASK_COMMENTS_GET;
var RECEIVE_TASK_COMMENTS = 'RECEIVE_TASK_COMMENTS';
exports.RECEIVE_TASK_COMMENTS = RECEIVE_TASK_COMMENTS;
var SET_PENDING_TASK_COMMENT_IDS = 'SET_PENDING_TASK_COMMENT_IDS';
exports.SET_PENDING_TASK_COMMENT_IDS = SET_PENDING_TASK_COMMENT_IDS;
var SET_IS_TASK_COMMENTS_PAGINATING = 'SET_IS_TASK_COMMENTS_PAGINATING';
exports.SET_IS_TASK_COMMENTS_PAGINATING = SET_IS_TASK_COMMENTS_PAGINATING;
var SET_IS_ALL_TASK_COMMENTS_FETCHED = 'SET_IS_ALL_TASK_COMMENTS_FETCHED';
exports.SET_IS_ALL_TASK_COMMENTS_FETCHED = SET_IS_ALL_TASK_COMMENTS_FETCHED;
var SET_OPEN_TASK_INSPECTOR_ID = 'SET_OPEN_TASK_INSPECTOR_ID';
exports.SET_OPEN_TASK_INSPECTOR_ID = SET_OPEN_TASK_INSPECTOR_ID;
var OPEN_TASK_INSPECTOR = 'OPEN_TASK_INSPECTOR';
exports.OPEN_TASK_INSPECTOR = OPEN_TASK_INSPECTOR;
var CLOSE_TASK_INSPECTOR = 'CLOSE_TASK_INSPECTOR';
exports.CLOSE_TASK_INSPECTOR = CLOSE_TASK_INSPECTOR;
var SET_SELECTED_PROJECT_LAYOUT_TYPE = 'SET_SELECTED_PROJECT_LAYOUT_TYPE';
exports.SET_SELECTED_PROJECT_LAYOUT_TYPE = SET_SELECTED_PROJECT_LAYOUT_TYPE;
var OPEN_CHECKLIST_SETTINGS = 'OPEN_CHECKLIST_SETTINGS';
exports.OPEN_CHECKLIST_SETTINGS = OPEN_CHECKLIST_SETTINGS;
var CLOSE_CHECKLIST_SETTINGS = 'CLOSE_CHECKLIST_SETTINGS';
exports.CLOSE_CHECKLIST_SETTINGS = CLOSE_CHECKLIST_SETTINGS;
var SET_INFORMATION_DIALOG = 'SET_INFORMATION_DIALOG';
exports.SET_INFORMATION_DIALOG = SET_INFORMATION_DIALOG;
var SET_CONFIRMATION_DIALOG = 'SET_CONFIRMATION_DIALOG';
exports.SET_CONFIRMATION_DIALOG = SET_CONFIRMATION_DIALOG;
var SET_ITEM_SELECT_DIALOG = 'SET_ITEM_SELECT_DIALOG';
exports.SET_ITEM_SELECT_DIALOG = SET_ITEM_SELECT_DIALOG;
var SET_QUICK_ITEM_SELECT_DIALOG = 'SET_QUICK_ITEM_SELECT_DIALOG';
exports.SET_QUICK_ITEM_SELECT_DIALOG = SET_QUICK_ITEM_SELECT_DIALOG;
var RECEIVE_LOCAL_MUI_THEMES = 'RECEIVE_LOCAL_MUI_THEMES';
exports.RECEIVE_LOCAL_MUI_THEMES = RECEIVE_LOCAL_MUI_THEMES;
var SELECT_MUI_THEME = 'SELECT_MUI_THEME';
exports.SELECT_MUI_THEME = SELECT_MUI_THEME;
var SET_IS_ONBOARDING = 'SET_IS_ONBOARDING';
exports.SET_IS_ONBOARDING = SET_IS_ONBOARDING;
var STEP_ONBOARDER_FORWARD = 'STEP_ONBOARDER_FORWARD';
exports.STEP_ONBOARDER_FORWARD = STEP_ONBOARDER_FORWARD;
var STEP_ONBOARDER_BACKWARDS = 'STEP_ONBOARDER_BACKWARDS';
exports.STEP_ONBOARDER_BACKWARDS = STEP_ONBOARDER_BACKWARDS;
var SET_IS_INDUCTING = 'SET_IS_INDUCTING';
exports.SET_IS_INDUCTING = SET_IS_INDUCTING;
var SET_LAST_UNDO_ACTION = 'SET_LAST_UNDO_ACTION';
exports.SET_LAST_UNDO_ACTION = SET_LAST_UNDO_ACTION;
var SET_UNDO_SNACKBAR = 'SET_UNDO_SNACKBAR';
exports.SET_UNDO_SNACKBAR = SET_UNDO_SNACKBAR;
var SET_IS_APP_DRAWER_COLLAPSED = 'SET_IS_APP_DRAWER_COLLAPSED';
exports.SET_IS_APP_DRAWER_COLLAPSED = SET_IS_APP_DRAWER_COLLAPSED;



//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-redux/action-types/index.js
// module id = 315
// module chunks = 0